import { action, makeObservable, observable } from 'mobx';

class BetBarStore {
  quickBetArr = [];

  quickBetDefaultArr = [];

  selectedAmount = null;

  isPointerDown = false;

  freeBetSelectedAmount = null;

  betButtonSprites = [];

  limits = {
    maxBet: 0,
    minBet: 0,
    maxOdd: 0,
    boostedJackpotBetAmount: 0,
  };

  selectedBetAmountIndex = 0;

  defaultBetAmount = null;

  constructor() {
    makeObservable(this, {
      freeBetSelectedAmount: observable,
      selectedBetAmountIndex: observable,
      defaultBetAmount: observable,
      isPointerDown: observable,
      selectedAmount: observable,
      limits: observable.deep,
      quickBetArr: observable.deep,
      betButtonSprites: observable.deep,
      quickBetDefaultArr: observable.deep,
      setLimits: action.bound,
      setQuickBetArr: action.bound,
      setQuickBetDefaultArr: action.bound,
      setIsPointerDown: action.bound,
      setSelectedAmount: action.bound,
      setDefaultBetAmount: action.bound,
      setBetButtonSprites: action.bound,
      setSelectedBetAmountIndex: action.bound,
      setFreeBetSelectedAmount: action.bound,
    });
  }

  setQuickBetDefaultArr(quickBets) {
    this.quickBetDefaultArr = quickBets;
  }

  setDefaultBetAmount(defaultBetAmount) {
    this.defaultBetAmount = defaultBetAmount;
  }

  setSelectedBetAmountIndex(index) {
    this.selectedBetAmountIndex = index;
  }

  setLimits(limits) {
    this.limits = limits;
  }

  setFreeBetSelectedAmount(amount) {
    this.freeBetSelectedAmount = amount;
  }

  setSelectedAmount(amount) {
    this.selectedAmount = amount;
    this.setSelectedBetAmountIndex(this.quickBetArr.findIndex((el) => +el === +amount));
  }

  setQuickBetArr(quickBets) {
    this.quickBetArr = quickBets;
  }

  setBetButtonSprites(texture) {
    this.betButtonSprites = [...this.betButtonSprites, texture];
  }

  setIsPointerDown(boolValue) {
    this.isPointerDown = boolValue;
  }
}

export const betBarStore = new BetBarStore();
